import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useRef, useState } from "react";
import LocationPicker from "../maps/LocationPicker";

const dialogPaperSx = {
  maxHeight: "90vh",
  height: "auto",
  display: "flex",
  flexDirection: "column",
  m: 1,
  overflow: "hidden",
};

const MapPicker = ({
  open,
  onClose,
  initialPosition = [32.68, 51.68],
  onSelect,
  title = "انتخاب موقعیت روی نقشه",
  readOnly = false,
}) => {
  const hasInitial =
    Array.isArray(initialPosition) &&
    initialPosition[0] &&
    initialPosition[1];

  const pickerRef = useRef(null);
  const [hasPosition, setHasPosition] = useState(!!hasInitial);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleConfirmClick = async () => {
    await pickerRef.current?.confirm();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: dialogPaperSx }}
    >
      <DialogTitle
        sx={{
          flexShrink: 0,
          pb: 1,
          fontSize: { xs: "0.875rem", sm: "0.9375rem" },
          fontWeight: 600,
        }}
      >
        {title}
        {readOnly && (
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ display: "block", mt: 1 }}
          >
            (فقط نمایش - قابل تغییر نیست)
          </Typography>
        )}
      </DialogTitle>

      <DialogContent
        sx={{
          flex: "1 1 auto",
          minHeight: 0,
          overflow: "hidden",
          py: 1.5,
          px: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <LocationPicker
          ref={pickerRef}
          variant="dialog"
          initialLat={hasInitial ? initialPosition[0] : null}
          initialLng={hasInitial ? initialPosition[1] : null}
          readonly={readOnly}
          showActions={false}
          onPositionChange={setHasPosition}
          onLoadingChange={setConfirmLoading}
          onConfirm={(location) => {
            onSelect({
              lat: location.lat,
              lng: location.lng,
              address: location.address,
              province: location.province,
              city: location.city,
              district: location.district,
              formattedAddress: location.formattedAddress,
              provider: location.provider,
            });
            onClose();
          }}
          onCancel={onClose}
        />
      </DialogContent>

      <DialogActions
        sx={{
          flexShrink: 0,
          px: 2,
          py: 1.5,
          gap: 1,
          borderTop: 1,
          borderColor: "divider",
        }}
      >
        <Button onClick={onClose} color="inherit" size="small">
          {readOnly ? "بستن" : "لغو"}
        </Button>
        {!readOnly && (
          <Button
            onClick={handleConfirmClick}
            variant="contained"
            size="small"
            disabled={!hasPosition || confirmLoading}
            startIcon={
              confirmLoading ? <CircularProgress size={16} color="inherit" /> : undefined
            }
          >
            {confirmLoading ? "در حال دریافت آدرس..." : "تایید"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MapPicker;
